const CAST_LINKS = {
  chemistry: {
    "Melissa Itwar": "https://www.imdb.com/name/nm10237283/",
    "Joseph Chiu": "https://www.imdb.com/name/nm14813005/",
  },
};

export default function CreditNames({ name, projectSlug, className = "" }) {
  const names = [...new Set(String(name || "").split(",").map((value) => value.trim()).filter(Boolean))];
  return names.map((person, index) => {
    const href = CAST_LINKS[projectSlug]?.[person];
    return (
      <span key={person}>
        {index > 0 && ", "}
        {href ? (
          <a href={href} target="_blank" rel="noopener noreferrer"
            className={`underline decoration-orange/60 underline-offset-4 transition-colors hover:text-orange ${className}`}>
            {person}
          </a>
        ) : person}
      </span>
    );
  });
}
